import { createRouter } from '@tanstack/react-router';
import { queryClient } from '@shared/api';
import { RouteErrorComponent, NotFoundComponent, RoutePending } from '@app/shell';
// Generated by @tanstack/router-plugin on dev/build (committed). Exists after first build.
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultPendingComponent: RoutePending,
  defaultErrorComponent: RouteErrorComponent,
  defaultNotFoundComponent: NotFoundComponent,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
